module.exports = __webpack_public_path__ + "img/IMG-20200609-WA0150.f8c8fafc.jpg";